// Please add this to prohabits-metaverse repo because we use it on ui
export const parseHTMLString = (value: string) => {
  /**
   * ! Important note
   * validator in a form,
   * validator can work well when the html tags are written in the correct syntax
   */
  return value.replace(/<\/?[^>]+(>|$)/g, '')
}
